export const COMMERCE_CATEGORY = {
  FREE: "commerce_free_media",
  MEMBER: "commerce_members_media",
  PPV: "commerce_ppv_media",
  TRANSACTIONAL: "commerce_transactional_media",
  SUBSCRIPTION: "commerce_subscription_basic_media",
} as const;

export const COMMERCE_TYPE = {
  PPV: "ppv",
  SVOD: "svod",
  CVOD: "cvod",
} as const;
